
import { react_api } from "../../config";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";



let toast;
let axiosInstance;
let translator;
// Funzione di inizializzazione per configurare le variabili
export const initLcaRepositoryHttpService = (translation, t, axiosInst) => {

    
  translator = translation;
  toast = t;
  axiosInstance = axiosInst;
};

const headersDefault = () => ({
    'Content-Type': 'application/json',
    'Authorization': sessionStorage.getItem("token")
  });
  
  const baseUrl = `${react_api}/lca-repo`;
  
  export const createNewFolder = async (body,parentFolderId, onCompleteToast) => {
    console.log(body)
    try {
      const response = await axiosInstance.post(`${baseUrl}/createNewFolder`, body, { headers:  {
  ...headersDefault(),
  'X-Parent-Folder-Id':parentFolderId 
} });
      const result = response.data;
  
      if (result.status.toString() === HTTP_STATUS_CODES.OK) {
        toast({
          title: result.message,
          status: 'success',
          duration: 1500,
          position: 'top',
          isClosable: true,
          onCloseComplete: onCompleteToast
        });
        return result;
      }
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }
  };
  

  
  export const getLcaRepository = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/getLcaRepository`, {
        headers: headersDefault()
      });
      return response.data;
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
      return null;
    }
  };
  
  export const uploadFile = async (file, { path, fileName, owner, folderId }, onCompleteToast) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
  
      const response = await axiosInstance.post(`${baseUrl}/uploadFile`, formData, {
        headers: {
          'Authorization': sessionStorage.getItem("token"),
          'path': path,
          'fileName': fileName,
          'owner': owner,
          'folderId': folderId
        }
      });
  
      const result = response.data;
      toast({
        title: translator('toastMsg.fileUploaded'),
        status: 'success',
        duration: 1500,
        position: 'top',
        isClosable: true,
        onCloseComplete: onCompleteToast
      });
    } catch (error) {
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }
  };

  export const downloadFile = async (filePath, owners, id) => {
    try {
    

      const response = await axiosInstance.get(`${baseUrl}/download-file?filePath=${encodeURIComponent(filePath)}`, {
        responseType: 'blob',
        headers: {
          'Authorization': sessionStorage.getItem("token"),
          'X-File-Owners': owners,
          'X-File-Id': id
        }
       
      });
  
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filePath.split('/').pop());
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.closeAll(); 
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }
  };
  
  export const downloadFolder = async (folderPath, owners, id) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/download-folder`, {
        responseType: 'blob',
        headers: {
          'Authorization': sessionStorage.getItem("token"),
          'X-Folder-Owners': owners,
          'X-Folder-Id': id
        },
        params: { folderPath }
      });
  
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${folderPath.replace(/[^a-zA-Z0-9-_]/g, '_')}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.closeAll(); 
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }



    
}





export const genericRepoAction = async (body, endpoint, method, onCompleteToast) => {
 
    try {

      const response = await axiosInstance[method](`${baseUrl}/${endpoint}`, body, { headers: headersDefault() });


      console.log(response,"ss")

      const result = response.data;
  
      if (result.status === HTTP_STATUS_CODES.OK) {
        toast.closeAll(); 
        toast({
          title: translator(result.message),
          status: 'success',
          duration: 1500,
          position: 'top',
          isClosable: true,
          onCloseComplete: onCompleteToast
        });

        return result
      }
    } catch (error) {

      console.log(error)
      toast({
        title: translator('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        position: 'top',
        isClosable: true
      });
    }
  };

export const renameFile = (body, onCompleteToast) => genericRepoAction(body, "renameFile", "put", onCompleteToast);
export const renameFolder = (body, onCompleteToast) => genericRepoAction(body, "renameFolder", "put", onCompleteToast);
export const deleteFile = (body, onCompleteToast) => genericRepoAction(body, "deleteFile", "post", onCompleteToast);
export const deleteFolder = (body, onCompleteToast) => genericRepoAction(body, "deleteFolder", "post", onCompleteToast);
export const moveFile = (body, onCompleteToast) => genericRepoAction(body, "moveFile", "post", onCompleteToast);
export const moveFolder = (body, onCompleteToast) => genericRepoAction(body, "moveFolder", "post", onCompleteToast);
export const copyFile = (body, onCompleteToast) => genericRepoAction(body, "copyFile", "post", onCompleteToast);
export const copyFolder = (body, onCompleteToast) => genericRepoAction(body, "copyFolder", "post", onCompleteToast);

